import React, { ReactNode } from 'react'

const Disclaimer = ({ children, style = {} }: { children: ReactNode; style?: React.CSSProperties }) => {
  return (
    <div
      style={{
        margin: '0.5rem 0',
        textAlign: 'start',
        fontSize: '13px',
        fontWeight: '400',
        color: 'var(--grey)',
        ...style,
      }}
    >
      {children}
    </div>
  )
}

export default Disclaimer
